// Generated by ReScript, PLEASE EDIT WITH CARE


var dummyResponse = {};

export {
  dummyResponse ,
}
/* No side effect */
